<template>
  <div class="page_two">
    <div class="page_two_title flex-eju-center">
      <div class="title_word">
        客户运营
        <div class="line_block"></div>
      </div>
    </div>
    <div class="card_list flex-eju-center">
      <div
        class="list_item animate__animated flex-eju-center"
        :class="[item.animate]"
        v-for="(item, index) in listData"
        :key="index"
      >
        <img class="img" :src="item.img" />
        <div class="title">{{ item.title }}</div>
        <div class="tip">{{ item.tip }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activePageIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    activePageIndex: {
      handler: function(val) {
        if (val === 1) {
          this.showPage = true;
        }
      },
    }
  },
  data() {
    return {
      showPage: false,
      listData: [
        {
          title: "打通客户微信",
          img: require("@/assets/svg/page_2/打通客户微信.svg"),
          tip: "微信即客户，免安装无骚扰",
          animate: "animate__fadeInUp",
        },
        {
          title: "个性化欢迎语",
          img: require("@/assets/svg/page_2/个性化欢迎语.svg"),
          tip: "专属客服，宾至如归",
          animate: "animate__fadeInDown",
        },
        {
          title: "精准客户标签",
          img: require("@/assets/svg/page_2/精准客户标签.svg"),
          tip: "建立客户标签，高效维护客户",
          animate: "animate__fadeInUp",
        },
        {
          title: "深耕群发朋友圈",
          img: require("@/assets/svg/page_2/深耕群发朋友圈.svg"),
          tip: "直接触达客户，批量“广告”营销",
          animate: "animate__fadeInDown",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.page_two {
  width: 100%;
  height: 100%;
  position: relative;
  flex-direction: column;
  padding-top: 8%;
  box-sizing: border-box;
  &::before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.6)), linear-gradient(107.73deg, #5500C1 0%, #0174FF 100%);
    background-image: url("../../../assets/svg/chart-bg.svg");
    background-size: 100%;
    background-position: center;
    opacity: 0.1;
  }
  .page_two_title {
    font-weight: 300;
    font-size: 40px;
    line-height: 56px;
    color: #fff;
    margin-bottom: 80px;
    .title_word {
      position: relative;
      padding-bottom: 16px;
      .line_block {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(105.88deg, #007aff 0%, #0057ff 100%);
        border-radius: 4px;
      }
    }
  }
  .list_item {
    width: 280px;
    height: 400px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    border-radius: 8px;
    margin: 0 10px;
    padding: 40px 0;
    flex-direction: column;
    color: #fff;
    .img {
      width: 200px;
      height: 200px;
      margin-bottom: 40px;
    }
    .title {
      font-weight: 500;
      font-size: 20px;
      line-height: 45px;
      margin-bottom: 12px;
    }
    .tip {
      font-size: 16px;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
